import {
    List,
    Datagrid,
    TextField,
    TopToolbar,
    DateField,
    useDataProvider,
    useNotify,
    useRefresh,
    CreateButton,
    TextInput,
    SaveButton,
    Toolbar,
    required,
    useRecordContext,
    Form,
    SelectField,
    FunctionField,
    useRedirect,
    Button,
    ShowButton
} from "react-admin";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Dialog, DialogTitle, DialogContent, Box, Grid, styled, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import { LogisticsDialog } from "../../Components/LogisticsDialog";
import { useFormContext } from "react-hook-form"

const CustomTextInput = (props: any) => {
    const form = useFormContext(); // 在表单上下文中安全使用

    useEffect(() => {
        if (props.value && props.value != 'undefined') {
            form.setValue(props.source, props.value);
        } else {
            form.setValue(props.source, '');
        }
    }, [props.value]);

    return (
        <TextInput {...props} />
    );
};


// 编辑表单组件
const OutboundEditForm = ({ open, onClose }) => {
    const record = useRecordContext();
    const notify = useNotify();
    const refresh = useRefresh();

    const [shippingAddress, setShippingAddress] = useState(record?.shippingAddress || '');

    const [logisticsNo, setLogisticsNo] = useState(record?.logisticsNo || '');
    const dataProvider = useDataProvider();

    // const { reset } = useFormContext();

    // useEffect(() => {
    //     if (open && record) {
    //         reset({
    //             logisticsNo: record?.logisticsNo && record.logisticsNo != 'undefined' ? record.logisticsNo : '',
    //             shippingAddress: record.shippingAddress && record.shippingAddress != 'undefined' ? record.shippingAddress : ''
    //         });
    //     }
    // }, [open, record, reset]);


    const handleSubmit = () => {
        // 准备更新数据
        const updateData = {
            logisticsNo: logisticsNo.trim(),
            shippingAddress: shippingAddress.trim(),
            outStockBatchNo: record?.outStockBatchNo
        };

        // 执行更新
        dataProvider.setLogisticsNo(updateData)
            .then(() => {
                notify('更新成功', { type: 'success' });
                refresh();
                onClose();
            })
            .catch((error) => {
                notify(error.message || '更新失败', { type: 'error' });
            });
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>编辑出库信息</DialogTitle>
            <DialogContent>
                <Form onSubmit={handleSubmit} >
                    <Grid container spacing={2} sx={{ padding: 2 }}>
                        <Grid item xs={12}>
                            <CustomTextInput
                                source="logisticsNo"
                                label="物流信息"
                                value={logisticsNo}
                                onChange={(e) => setLogisticsNo(e.target.value)}
                                fullWidth
                                validate={required()}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <CustomTextInput
                                source="shippingAddress"
                                label="收货地址"
                                value={shippingAddress}
                                onChange={(e) => {
                                    setShippingAddress(e.target.value);
                                }}
                                fullWidth
                                multiline
                                minRows={3}
                            />
                        </Grid>
                    </Grid>
                    <Toolbar sx={{ justifyContent: 'flex-end', marginTop: 2 }}>
                        <Button label="取消" onClick={onClose} />
                        <SaveButton label="保存" />
                    </Toolbar>
                </Form>
            </DialogContent>
        </Dialog>
    );
};

// 行内编辑按钮
const RowEditButton = () => {
    const record = useRecordContext();
    const [open, setOpen] = useState(false);

    return (
        <>
            <Button onClick={() => setOpen(true)} >编辑物流信息</Button>
            {record && (
                <OutboundEditForm
                    open={open}
                    onClose={() => setOpen(false)}
                />
            )}
        </>
    );
};

const ListActions = () => {
    const redirect = useRedirect(); // 添加重定向功能

    // 处理批量导入按钮点击
    const handleBatchImportClick = () => {
        // 重定向到创建页面，并传递模式参数
        redirect('BatchCreate', 'outboundProduct');
    };
    const templateUrl = "https://iot-edge-dev.oss-cn-heyuan.aliyuncs.com/templates/产品出库模板.xlsx";
    return (
        <TopToolbar sx={{ alignItems: "center" }}>
            <CreateButton label="新增出库" />
            <Button
                size="small"
                component="a"
                label="下载模板"
                href={templateUrl}
                download="产品出库模板.xlsx"
                startIcon={<DownloadIcon />}
                sx={{ ml: 1 }}
            >
            </Button>
            <Button
                size="small"
                label="批量导入"
                component="span"
                startIcon={<FileUploadIcon />}
                onClick={handleBatchImportClick}
            >
            </Button>
        </TopToolbar>
    );
};


const ClickableLogisticsInfo = ({ record }) => {
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleClick = () => {
        if (isLogisticsNo(record.logisticsNo)) {
            setDialogOpen(true);
        }
    };

    const isLogisticsNo = (logisticsNo: any) => {
        if (!logisticsNo || logisticsNo == 'undefined') {
            return false
        }
        return true
    }

    return (
        <>
            <Typography
                variant="body2"
                onClick={handleClick}
                sx={{
                    cursor: isLogisticsNo(record.logisticsNo) ? 'pointer' : 'default',
                    color: isLogisticsNo(record.logisticsNo) ? 'primary.main' : 'text.primary',
                    textDecoration: isLogisticsNo(record.logisticsNo) ? 'underline' : 'none',
                    whiteSpace: 'nowrap',
                }}
            >
                {isLogisticsNo(record.logisticsNo) ? record.logisticsNo : '无'}
            </Typography>

            <LogisticsDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                logisticsNo={record.logisticsNo}
            />
        </>
    );
};


export const outboundProductList = () => {
    const refresh = useRefresh();
    const notify = useNotify();
    const dataProvider = useDataProvider();
    const [manufacturerTypes, setManufacturerTypes] = useState([]);
    const [customerTypeChoices, setSaleCustomers] = useState([]);
    const hasFetched = useRef(false); // 添加 useRef 标记

    useEffect(() => {
        if (hasFetched.current) {
            return;
        }
        const token = localStorage.getItem("authToken");
        if (!token) {
            return; // 如果没有 token，则不请求
        }
        hasFetched.current = true; // 标记已请求

        const fetchData = async () => {
            try {
                // 使用 Promise.all 同时获取两个数据
                let [manufacturerTypes, salesCustomers] = await Promise.all([
                    dataProvider.getManufacturerTypes(),
                    dataProvider.getSalesCustomers()
                ]);
                manufacturerTypes = manufacturerTypes ? manufacturerTypes : [];
                salesCustomers = salesCustomers ? salesCustomers : [];
                setManufacturerTypes(manufacturerTypes);
                setSaleCustomers(salesCustomers);
            } catch (error) {
                console.error("获取数据失败:", error);
                // 如果是 401 错误，不显示通知（httpClient 会处理跳转）
                if (error.status !== 401) {
                    notify("获取数据失败", { type: 'error' });
                }
            }
        };

        fetchData();
    }, []); // 依赖数组为空，只运行一次


    let cancelStore = (outStockBatchNo: any) => {
        if (window.confirm(`确认取消暂存:${outStockBatchNo}？`)) {
            dataProvider.cancelTempOutStock(outStockBatchNo)
                .then(() => {
                    refresh();
                    notify('取消暂存成功', { type: 'success' });
                })
                .catch((error: any) => {
                    notify(error.message || '取消暂存失败', { type: 'error' });
                })
        }
    }

    let cancelShipment = (outStockBatchNo: any) => {
        if (window.confirm(`确认出库:${outStockBatchNo}？`)) {
            dataProvider.confirmOutStock(outStockBatchNo)
                .then(() => {
                    refresh();
                    notify('确认出库成功', { type: 'success' });
                })
                .catch((error: any) => {
                    notify(error.message || '确认出库失败', { type: 'error' });
                })
        }


    }


    return (
        <List
            sx={{
                '.MuiToolbar-root': { width: '100%' },
                '.MuiDialog-paper': { maxWidth: '600px' }
            }}
            filter={{ status: '1' }}
            actions={<ListActions />}
            empty={false}
        >
            <Datagrid bulkActionButtons={false} rowClick={false}>
                <TextField source="id" label="序号" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                {/* 使用自定义SnField组件显示SN号 */}
                <TextField source="outStockBatchNo" label="批次号" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="deviceType" label="设备类型" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="productModel" label="产品型号" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="outStockCount" label="出库数量" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <SelectField source="manufacturerId" label="制造工厂" choices={manufacturerTypes} sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <DateField source="createTime" label="暂存出库" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <SelectField source="saleCustomerId" label="设备商家" choices={customerTypeChoices} sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <FunctionField
                    label="物流信息"
                    sortable={false}
                    render={(record) => (
                        <ClickableLogisticsInfo record={record} />
                    )}
                    sx={{
                        whiteSpace: 'nowrap',
                    }}
                />
                <FunctionField
                    label="收货地址"
                    sortable={false}
                    source="shippingAddress"
                    render={(record) => {
                        let src = record.shippingAddress
                        if (!src || src == 'undefined') {
                            src = ''
                        }
                        return src
                    }
                    }
                />

                <FunctionField
                    label="操作"
                    render={(record) => (
                        <Box sx={{ justifyContent: 'center', display: 'flex', gap: '8px' }}>
                            <RowEditButton />
                            <ShowButton
                                label="详情"
                                record={{ id: record.outStockBatchNo }}
                            />
                            <Button onClick={() => { cancelStore(record.outStockBatchNo) }}>取消暂存</Button>
                            <Button onClick={() => { cancelShipment(record.outStockBatchNo) }}>确认出库</Button>
                        </Box>
                    )}
                />
            </Datagrid>
        </List>
    )
}